<div class="institution-list__header">
  <div>{{ peer()?.group?.name }}</div>
</div>
<div class="institution-list">
  @for (institution of institutions(); track institution.iid) {
  <div class="institution-list__item">{{ institution.label }}</div>
  }
</div>
